var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#f6f6f7"}},[_c('pcHeaders'),_c('payorder'),_c('pcBottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }